import { lazyLoad } from 'utils/loadable';

export const AuditLog = lazyLoad(
  () => import('./auditLog.page'),
  (module) => module.AuditLog
);
